var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.505782 11.6437C0.203905 11.9422 0.127552 12.4007 0.31639 12.7809C0.61459 13.3814 1.41286 13.5144 1.88957 13.0429L7.28111 7.71103C7.6769 7.31962 7.6769 6.68037 7.28111 6.28897L1.88957 0.957075C1.41286 0.485647 0.61459 0.618582 0.31639 1.21905C0.127552 1.59931 0.203905 2.0578 0.505781 2.35634L4.48241 6.28897C4.87819 6.68037 4.87819 7.31962 4.48241 7.71103L0.505782 11.6437Z"}));
}

ArrowRight.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
